import { useQuery } from "react-query";
import { getXbrlErrorMessages } from "./gateway";

function useGetXbrlErrorMessages(guid: string) {
  return useQuery({
    queryFn: () => getXbrlErrorMessages(guid),
    queryKey: ["getXbrlErrorMessages", guid],
  });
}

export default useGetXbrlErrorMessages;
